import { render, staticRenderFns } from "./ChooseActivity.vue?vue&type=template&id=31a3274e&"
import script from "./ChooseActivity.vue?vue&type=script&lang=js&"
export * from "./ChooseActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports